// Upsell trong cart drawer: đổ 4 sp gợi ý vào .kz-upsell, thêm nhanh kèm chọn size.
(function () {
  var money = function (c) { return '$' + (c / 100).toFixed(2).replace(/\.00$/, ''); };
  var cache = {};
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function card(p, big) {
    var vs = p.variants.filter(function (v) { return v.available; });
    if (!vs.length) return '';
    var img = p.featured_image ? p.featured_image.replace(/(\.\w+)(\?|$)/, big ? '_400x$1$2' : '_200x$1$2') : '';
    var opts = vs.map(function (v) { return '<option value="' + v.id + '">' + esc(v.title) + '</option>'; }).join('');
    return '<div class="kz-upsell__item">' +
      (img ? '<a href="' + p.url + '"><img src="' + esc(img) + '" alt="" loading="lazy" width="64" height="64"></a>' : '') +
      '<div class="kz-upsell__info"><a href="' + p.url + '" class="kz-upsell__name">' + esc(p.title) + '</a>' +
      '<div class="kz-upsell__row"><span>' + (big && p.price_varies ? 'From ' : '') + money(p.price) + '</span>' +
      '<select aria-label="Option">' + opts + '</select>' +
      '<button type="button" class="kz-upsell__add">' + (big ? 'Quick buy' : 'Add') + '</button></div></div></div>';
  }
  // Chấm trượt dưới carousel drawer (như Yujin), bấm chấm để nhảy tới thẻ
  function dots(box, listEl) {
    var n = listEl.children.length;
    if (n < 2) return;
    var d = document.createElement('div');
    d.className = 'kz-upsell__dots';
    for (var i = 0; i < n; i++) d.innerHTML += '<button type="button" aria-label="Item ' + (i + 1) + '"' + (i ? '' : ' class="on"') + '></button>';
    box.appendChild(d);
    var cur = function () { return Math.round(listEl.scrollLeft / (listEl.children[0].offsetWidth + 12)); };
    listEl.addEventListener('scroll', function () {
      var k = cur();
      [].forEach.call(d.children, function (b, i) { b.classList.toggle('on', i === k); });
    }, { passive: true });
    d.addEventListener('click', function (e) {
      var i = [].indexOf.call(d.children, e.target);
      if (i >= 0) listEl.scrollTo({ left: listEl.children[i].offsetLeft - listEl.children[0].offsetLeft, behavior: 'smooth' });
    });
  }
  function fill(box) {
    if (box.dataset.done) return;
    box.dataset.done = '1';
    var pid = box.dataset.pid;
    var pdpBox = box.classList.contains('kz-upsell--pdp');
    var go = function (list) {
      var html = list.filter(function (p) { return String(p.id) !== pid; }).slice(0, +(box.dataset.limit || 4)).map(function (p) { return card(p, !pdpBox); }).join('');
      if (!html) { box.remove(); return; }
      var listEl = box.querySelector('.kz-upsell__list');
      listEl.innerHTML = html;
      if (!pdpBox) dots(box, listEl);
      box.classList.add('is-ready');
    };
    if (cache[pid]) return go(cache[pid]);
    fetch('/recommendations/products.json?limit=6&intent=related&product_id=' + pid)
      .then(function (r) { return r.json(); })
      .then(function (j) { cache[pid] = j.products || []; go(cache[pid]); })
      .catch(function () { box.remove(); });
  }
  function scan() { document.querySelectorAll('.kz-upsell:not([data-done])').forEach(fill); }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.kz-upsell__add');
    if (!b) return;
    var pdp = b.closest('.kz-upsell--pdp');
    var id = b.closest('.kz-upsell__item').querySelector('select').value;
    b.disabled = true; b.textContent = '…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: +id, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble' }),
    }).then(function (r) { return r.json(); }).then(function (j) {
      var d = document.querySelector('cart-drawer');
      if (d && j.sections) { d.classList.remove('is-empty'); d.renderContents({ id: +id, sections: j.sections }); }
      else location.href = '/cart';
      if (pdp) { b.textContent = 'Added'; setTimeout(function () { b.disabled = false; b.textContent = 'Add'; }, 2500); }
    }).catch(function () { b.disabled = false; b.textContent = 'Add'; });
  });
  new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', scan);
  scan();
})();
